import {
  ADD_FAVOURITE_PROJECT_BUS_PRIORITY,
  ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS,
  FETCH_PROJECT_BUS_PRIORITY,
  FETCH_PROJECT_BUS_PRIORITY_SUCCESS,
  FETCH_ALL_PROJECT_BUS_PRIORITY,
  FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS,
  FILTER_PROJECT_BUS_PRIORITY,
  GET_ALL_PROJECT_BUS_PRIORITY,
  GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY,
  HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE,
  HIDE_PROJECT_BUS_PRIORITY_LOADER,
  SHOW_PROJECT_BUS_PRIORITY_LOADER,
  ON_ADD_PROJECT_BUS_PRIORITY,
  ON_EDIT_PROJECT_BUS_PRIORITY,
  ON_ALL_PROJECT_BUS_PRIORITY_SELECT,
  ON_PROJECT_BUS_PRIORITY_CLOSE,
  ON_PROJECT_BUS_PRIORITY_SELECT,
  ON_DELETE_PROJECT_BUS_PRIORITY,
  ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS,
  ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY,
  ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT,
  ON_SAVE_PROJECT_BUS_PRIORITY,
  ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS,
  ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER,
  SHOW_PROJECT_BUS_PRIORITY_MESSAGE,
  UPDATE_SEARCH_PROJECT_BUS_PRIORITY,
} from 'constants/ActionTypes';

export const fetchProjectBusPriority = (payload) => {
  return {
      type: FETCH_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const fetchProjectBusPrioritySuccess = (payload) => {
  return {
      type: FETCH_PROJECT_BUS_PRIORITY_SUCCESS,
      payload
  };
};
export const fetchProjectBusPrioritys = () => {
  return {
      type: FETCH_ALL_PROJECT_BUS_PRIORITY
  };
};
export const fetchProjectBusPrioritysSuccess = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS,
      payload
  };
};
export const showProjectBusPriorityMessage = (message) => {
  return {
      type: SHOW_PROJECT_BUS_PRIORITY_MESSAGE,
      payload: message
  };
};
export const addFavouriteProjectBusPriority = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const addFavouriteProjectBusPrioritySuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS,
      payload
  };
};
export const onProjectBusPrioritySelect = (payload) => {
  return {
      type: ON_PROJECT_BUS_PRIORITY_SELECT,
      payload
  };
};
export const onAddProjectBusPriority = () => {
  return {
      type: ON_ADD_PROJECT_BUS_PRIORITY,
  };
};
export const onEditProjectBusPriority = (payload) => {
  return {
      type: ON_EDIT_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const onProjectBusPriorityClose = () => {
  return {
      type: ON_PROJECT_BUS_PRIORITY_CLOSE,
  };
};
export const onFilterProjectBusPriorityOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT,
      payload
  };
};
export const onSaveProjectBusPriority = (payload) => {
  return {
      type: ON_SAVE_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const onSaveProjectBusPrioritySuccess = (data) => {
  return {
      type: ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS,
      payload: data
  };
};
export const onDeleteProjectBusPriority = (payload) => {
  return {
      type: ON_DELETE_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const onDeleteProjectBusPrioritySuccess = (payload) => {
  return {
      type: ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS,
      payload
  };
};
export const onFilterSelectedProjectBusPriority = () => {
  return {
      type: ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY,
      payload: ''
  };
};
export const filterProjectBusPriority = (payload) => {
  return {
      type: FILTER_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const getAllProjectBusPriority = () => {
  return {
      type: GET_ALL_PROJECT_BUS_PRIORITY,
      payload: ''
  };
};
export const getUnselectedAllProjectBusPriority = () => {
  return {
      type: GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY,
      payload: ''
  };
};
export const onAllProjectBusPrioritySelect = () => {
  return {
      type: ON_ALL_PROJECT_BUS_PRIORITY_SELECT,
      payload: ''
  };
};
export const updateSearchProjectBusPriority = (payload) => {
  return {
      type: UPDATE_SEARCH_PROJECT_BUS_PRIORITY,
      payload
  };
};
export const onToggleProjectBusPriorityDrawer = () => {
  return {
      type: ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER,
  };
};
export const handleProjectBusPriorityRequestClose = () => {
  return {
      type: HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE,
  };
};
export const showProjectBusPriorityLoader = () => {
  return {
      type: SHOW_PROJECT_BUS_PRIORITY_LOADER,
  };
};
export const hideProjectBusPriorityLoader = () => {
  return {
      type: HIDE_PROJECT_BUS_PRIORITY_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/projectBusPriority.js